export default class Health {
    static preload(scene){
        scene.load.image('life', 'src/assets/img/fox2.png');
    }

    constructor({scene}){
        this.scene = scene;
        this.container = this.scene.rexUI.add.sizer({
            orientation: "x",
            anchor: "center",
            x:170,
            y:60
        });
        for(let i = 0; i < 3; i++){
            const life = scene.add.image(0, 0, "life");
            life.setScale(0.101);

            life.filter = {
                grayscale: this.scene.plugins.get('rexGrayScalePipeline').add(life, { intensity: 0 })
            };

            this.container.add(life);
        }
        this.container.layout();
        this.life = 3;
    }

    removeLife(){
        this.life--;
        this.container.children[this.life].filter.grayscale.intensity = 0.9;
    }
}